import React from 'react';
import { MoonIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-[#1a1f2e] to-[#0f1419] py-16 md:py-24 px-4" data-id="element-120">
      <div className="max-w-6xl mx-auto" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-122">
          {/* Left: Text Content */}
          <div className="space-y-8" data-id="element-123">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#8b9dc3]/20 rounded-full ring-1 ring-[#8b9dc3]/30" data-id="element-124">
              <MoonIcon className="w-5 h-5 text-[#a8b5d1]" aria-hidden="true" data-id="element-125" />
              <span className="text-sm font-medium text-[#e8edf4]" data-id="element-126">
                Protocolo Anti-Ansiedad Nocturna
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#e8edf4] leading-tight" data-id="element-127">
              Si tu mente se prende cuando te acuestas, esto es para ti.
            </h1>

            <p className="text-xl md:text-2xl text-[#d1d9e6] leading-relaxed" data-id="element-128">
              El plan de 10 minutos (y el plan 3AM) para dejar de pelear con la
              noche.
            </p>

            <button onClick={() => {
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="bg-[#e76f51] hover:bg-[#d65d3f] text-white font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-200 shadow-lg shadow-[#e76f51]/20 hover:shadow-xl hover:shadow-[#e76f51]/30 focus:outline-none focus:ring-4 focus:ring-[#a8b5d1]/30" aria-label="Descarga el Protocolo Ahora" data-id="element-129">
              Descarga el Protocolo Ahora
            </button>
          </div>

          {/* Right: Product Image */}
          <div className="flex justify-center lg:justify-end" data-id="element-130">
            <img src="https://cdn.magicpatterns.com/uploads/mnykQbXiouFgvBKabP9vrw/PORTADA_1_APAGA_LA_CABEZA_EN_10_MIN.png" alt="Portada del protocolo Apaga la Cabeza en 10 Min" className="w-full max-w-md rounded-2xl shadow-2xl shadow-black/40 ring-1 ring-white/5" data-id="element-131" />
          </div>
        </div>
      </div>
    </section>;
}